import qs from 'qs';
import { AxiosInstance } from 'axios';
import { TaskKanbanResource } from './resources';
import { TaskKanbanFilterInput } from './inputs';

export default class TaskKanban {
    private basePath = '/api/task-kanban';
    private http: AxiosInstance;

    constructor(http: AxiosInstance) {
        this.http = http;
    }

    // Get kanban board
    get = async (filter?: TaskKanbanFilterInput): Promise<TaskKanbanResource> => {
        const query = qs.stringify({ ...(filter || {}) });

        const { data } = await this.http.get(`${this.basePath}/?${query}`);

        return data;
    };
}
